/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAssetUploadedBody
 */
export interface CreateAssetUploadedBody {
    /**
     * 
     * @type {string}
     * @memberof CreateAssetUploadedBody
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAssetUploadedBody
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAssetUploadedBody
     */
    description?: string;
}

export function CreateAssetUploadedBodyFromJSON(json: any): CreateAssetUploadedBody {
    return CreateAssetUploadedBodyFromJSONTyped(json, false);
}

export function CreateAssetUploadedBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAssetUploadedBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': json['fileName'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function CreateAssetUploadedBodyToJSON(value?: CreateAssetUploadedBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileName': value.fileName,
        'name': value.name,
        'description': value.description,
    };
}


